module.exports = __webpack_public_path__ + "img/scope_hightlight.f093d4d5.png";